module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/th/2/3-ba284c0836a85a622051b91a2126337b.jpg";